import CustomIcon from "../../../../components/CustomIcon";
import ToggleSwitch from "../../../../components/toggleSwitch/ToggleSwitch";
import {addAreas, enableDisableArea, enableDisableCity, modifyArea} from "../../../../redux/slices/locationSlice";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {UpdateAreaFormModal} from "../UpdateAreaFormModal";
import {cloneDeep, isEmpty} from "lodash";
import {AddAreasModal} from "../AddAreasModal";
import {mapAndFilterUndefinedValues, mapAndParseObjectValueToNumberIfPossible} from "../../../../helpers/objectHelper";

const AreaDetail = ({isAddingAreas, setIsAddingAreas}) => {
  const {
    area,
    province,
    city,
    currentCity,
    currentArea,
    processing
  } = useSelector((state => state.location))

  const dispatch = useDispatch();

  const [isEditingArea, setIsEditingArea] = useState(false)

  useEffect(() => {
    setIsEditingArea(false)
  }, [area])

  const onAreaUpdate = (updatedArea) => {
    // id and disabled fields are excluded in backend so removing from payload
    // more info -> Aparana
    delete updatedArea["id"]
    delete updatedArea["disabled"]
    let areaPayload = {
      max_shippable_weight: parseFloat(updatedArea.max_shippable_weight),
      ...(updatedArea?.discount_percentage?.length > 0 && {discount_percentage: parseFloat(updatedArea.discount_percentage)}),
      name: updatedArea.name,
      weight: {
        max_shipping_charge: parseFloat(updatedArea.weight.max_shipping_charge),
        weight_increment_threshold: parseFloat(updatedArea.weight.weight_increment_threshold),
        charges: mapAndParseObjectValueToNumberIfPossible(updatedArea.weight.charges)
      },
      price: {
        rate: parseFloat(updatedArea.price.rate),
        discounts: mapAndParseObjectValueToNumberIfPossible(mapAndFilterUndefinedValues(updatedArea.price.discounts))
      }
    }
    dispatch(modifyArea({areaId: currentArea?.id, updatedArea: areaPayload}))
  }

  return (
    <>{
      !isEmpty(currentArea) &&
      (
        <div className="px-4 py-4 bg-white shadow rounded-xl">
          <div className="flex justify-between">
            <h1>Area</h1>
            <div>
              <CustomIcon icon="edit" className="cursor-pointer" onClick={() => {
                setIsEditingArea(true)
              }}/>

              <ToggleSwitch
                isChecked={!currentArea?.disabled}
                isDisabled={area.loading || currentCity.disabled}
                onChange={() => {
                  //TODO setCurrentArea({...currentArea, disabled: !currentArea?.disabled})
                  dispatch(enableDisableArea({
                    areaId: currentArea?.id,
                    value: !currentArea?.disabled
                  }))
                }}/>
            </div>


          </div>
          <div className="flex py-5 space-x-5">
            <div>Allow for campaign</div>
            <ToggleSwitch
              isChecked={currentArea?.campaign_location}
              isDisabled={area.loading || !currentCity.campaign_location}
              onChange={() => {
                //TODO setCurrentArea({...currentArea, disabled: !currentArea?.disabled})
                dispatch(enableDisableArea({
                  areaId: currentArea?.id,
                  value: !currentArea?.campaign_location,
                  isCampaign: true
                }))
              }}/>
          </div>
          {province.loading || city.loading || area.loading ?
            <div>
              <div className="w-48 h-6 mb-4 bg-secondary-100"/>
              <div className="space-y-2">
                <div className="space-y-1">
                  <div className="w-48 h-6 bg-secondary-100"/>
                  <div className="w-48 h-6 bg-secondary-100"/>
                </div>
                <div>
                  <div className="font-bold underline">Price</div>
                  <div className="w-48 h-6 bg-secondary-100"/>
                  <div className="space-y-1">
                    <div>Discount Rates</div>
                    {[1, 2].map((d, index) => {
                      return <div key={`discount-rate-${d}`} className="w-full h-6 bg-secondary-100"/>
                    })}
                  </div>
                </div>
                <div>
                  <div className="font-bold underline">Weight</div>
                  <div className="space-y-1">
                    <div className="w-48 h-6 bg-secondary-100"/>
                    <div className="w-48 h-6 bg-secondary-100"/>
                  </div>
                  <div className="space-y-1">
                    <div>Charge Rates</div>
                    {[1, 2].map((w, index) => {
                      return <div key={`charge-rate-${w}`} className="w-full h-6 bg-secondary-100"/>
                    })}
                  </div>
                </div>
              </div>
            </div> :
            <div>
              <div className="mb-2 font-bold">{currentArea?.name}</div>
              <div className="space-y-2">
                <div>
                  <div>Max Shippable Weight: {currentArea?.max_shippable_weight}</div>
                  <div>Discount: {currentArea?.discount_percentage} %</div>
                </div>
                <div>
                  <div className="font-bold underline">Price</div>
                  <div>Rate: {currentArea?.price?.rate}</div>
                  <div>
                    <div>Discount Rates</div>
                    {currentArea?.price?.discounts.map((d, index) => {
                      return <div key={`price-discount-rate-${d.toString()}-${index}`}
                                  className="flex items-center h-8 px-2 py-1 mb-1 text-sm font-light bg-white border rounded space-x-2">
                        <div>{index + 1}.</div>
                        <div>Rs. ({d?.min}-{d?.max ?? 'N/A'})</div>
                        <div className="h-full w-0.5 bg-gray-300"/>
                        <div>Discount: {d?.discount_amt ?? "N/A"}</div>
                      </div>
                    })}
                  </div>
                </div>
                <div>
                  <div className="font-bold underline">Weight</div>
                  <div>
                    <div>Max Shipping Charge: {currentArea?.weight?.max_shipping_charge}</div>
                    <div>Weight Increment Threshold: {currentArea?.weight?.weight_increment_threshold}</div>
                  </div>
                  <div>
                    <div>Charge Rates</div>
                    {currentArea?.weight?.charges.map((w, index) => {
                      return <div key={`weight-charge-rate${w.toString()}-${index}`}
                                  className="flex items-center h-8 px-2 py-1 mb-1 text-sm font-light bg-white border rounded space-x-2">
                        <div>{index + 1}.</div>
                        <div>({w?.min}-{w?.max ?? 'N/A'}) {w?.unit ?? "N/A"}</div>
                        <div className="h-full w-0.5 bg-gray-300"/>
                        <div>Inc factor: {w?.inc_factor ?? "N/A"}</div>
                        <div className="h-full w-0.5 bg-gray-300"/>
                        <div>Rate: {w?.rate ?? "N/A"}</div>
                      </div>
                    })}
                  </div>
                </div>
              </div>
            </div>
          }

        </div>
      )
    }

      {/*Update Area Form*/}
      {isEditingArea &&
        <UpdateAreaFormModal processing={processing} area={cloneDeep(currentArea)} isEditingArea={isEditingArea}
                             setIsEditingArea={setIsEditingArea} onSubmit={onAreaUpdate}/>}


      {/*add areas under city*/}
      {isAddingAreas && <AddAreasModal title="Add Areas" disabled={processing} showModal={isAddingAreas}
                                       setShowModal={setIsAddingAreas}
                                       onAdd={(areas) => {
                                         dispatch(addAreas({cityId: currentCity?.id, areas: areas}))
                                       }}/>
      }
    </>
  )
}

export default AreaDetail;
